"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageConfetti = void 0;
const confetti_js_1 = __importDefault(require("confetti-js"));
const React = __importStar(require("react"));
const react_1 = require("react");
const utils_1 = require("./utils");
const confettiSettingsTemplate = {
    target: 'confetti-canvas',
    clock: 50,
    max: 50,
    fps: 60,
    rotate: false,
};
function ImageConfetti({ duration = 2000, fadeOut = 1000, images, onAnimationCompleted, particleCount = 50, rotate = false, runAnimation, speed = 50, }) {
    // track previous value so animation is only triggered once
    const previousRunAnimation = utils_1.usePrevious(runAnimation);
    // allow canvas to be manipulated directly
    const canvasRef = react_1.useRef();
    // keep confetti object persistent between renders
    const confetti = react_1.useRef();
    // cleanup animation on unmount
    react_1.useEffect(() => {
        return () => {
            if (confetti.current) {
                confetti.current.clear();
                confetti.current = null;
            }
            onAnimationCompleted && onAnimationCompleted();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // run the animation when 'runAnimation' changes from 'false' to 'true'
    react_1.useEffect(() => {
        let timer1, timer2;
        if (runAnimation && !previousRunAnimation) {
            // create confetti instance
            if (!confetti.current) {
                const settings = Object.assign(Object.assign({}, confettiSettingsTemplate), { max: particleCount, clock: speed, rotate: rotate, props: images.map(({ src, size = 24, weight = 1 }) => (Object.assign({ type: 'svg' }, { src, size, weight }))) });
                confetti.current = confetti_js_1.default(settings);
                if (confetti.current)
                    confetti.current.render();
            }
            // start fade out after 1 second
            if (fadeOut !== false && fadeOut > 0) {
                timer1 = setTimeout(() => {
                    if (canvasRef && canvasRef.current) {
                        canvasRef.current.style.opacity = '0';
                    }
                    clearInterval(timer1);
                }, duration - fadeOut);
            }
            // stop animation after 1.5 seconds
            timer2 = setTimeout(() => {
                if (confetti.current)
                    confetti.current.clear();
                onAnimationCompleted && onAnimationCompleted();
                clearInterval(timer2);
            }, duration);
        }
    }, [runAnimation, previousRunAnimation, onAnimationCompleted, duration, fadeOut, images, speed, rotate, particleCount]);
    return (React.createElement("canvas", { id: "confetti-canvas", ref: node => canvasRef.current = node, style: {
            display: runAnimation ? 'block' : 'none',
            position: 'absolute',
            top: 0,
            left: 0,
            opacity: 1,
            zIndex: 2000,
            transition: 'opacity ' + (fadeOut !== null && fadeOut !== void 0 ? fadeOut : 0) + 'ms',
        } }));
}
exports.ImageConfetti = ImageConfetti;
//# sourceMappingURL=ImageConfetti.js.map